export type ExtensionsList = {
  name: 'Chrome' | 'Firefox' | 'Edge' | 'Safari';
  link: string;
  reviewLink: string;
  Icon: string;
  extId: string;
};

const imageBaseURL = 'https://assets.share-a-cart.com/images/next/plugin-';

export const extensionsList: ExtensionsList[] = [
  {
    name: 'Chrome',
    link: 'https://chrome.google.com/webstore/detail/share-a-cart/hcjohblbkdgcoikaedjndgbcgcfoojmj',
    reviewLink: 'https://chromewebstore.google.com/detail/share-a-cart-%E2%80%93-easily-sha/hcjohblbkdgcoikaedjndgbcgcfoojmj/reviews#:~:text=Write%20a%20review',
    Icon: `${imageBaseURL}chrome.svg`,
    extId: 'hcjohblbkdgcoikaedjndgbcgcfoojmj', // chrome prod
  },
  {
    name: 'Edge',
    link: 'https://microsoftedge.microsoft.com/addons/detail/bgangcfogcfpakhljddkcjaaganbndeh',
    reviewLink: 'https://microsoftedge.microsoft.com/addons/detail/shareacart-%E2%80%93-easily-sha/bgangcfogcfpakhljddkcjaaganbndeh#:~:text=Add%20a%20review',
    Icon: `${imageBaseURL}edge.svg`,
    extId: 'bgangcfogcfpakhljddkcjaaganbndeh', // edge prod
  },
  {
    name: 'Firefox',
    link: 'https://addons.mozilla.org/en-US/firefox/addon/share-a-cart-for-everything/',
    reviewLink: 'https://addons.mozilla.org/en-US/firefox/addon/share-a-cart-for-everything/',
    Icon: `${imageBaseURL}firefox.svg`,
    extId: '{c0257452-ac3b-4d2f-9b73-f556992f9bb7}',
  },
  {
    name: 'Safari',
    link: 'https://apps.apple.com/us/app/share-a-cart-for-everything/id1537641390',
    reviewLink: 'https://apps.apple.com/us/app/share-a-cart/id1537641390',
    Icon: `${imageBaseURL}safari.svg`,
    extId: 'com.shareacart.Share-A-Cart-for-Everything.Extension (QZSD6Q9S74)',
  },
];
